import React from 'react';

import Button from '@material-ui/core/Button';
import Dialog, { DialogProps } from '@material-ui/core/Dialog';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import DialogPaper from '../DialogPaper';

const useStyles = makeStyles((theme) => ({
  buttonContainer: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(3),
  },
  cardContainer: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(),
    width: '100%',
  },
  title: {
    marginTop: theme.spacing(2),
    fontWeight: theme.typography.fontWeightBold,
    textAlign: 'left',
  },
  subtext: {
    marginTop: theme.spacing(2),
    textAlign: 'left',
    fontSize: 16,
  },
  avatar: {
    height: 80,
    width: 80,
    boxShadow: '0 2px 10px rgba(199, 199, 199, 0.5)',
    marginTop: theme.spacing(5),
    marginBottom: theme.spacing(3),
  },
  textField: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  grow: {
    flexGrow: 1,
  },
  actionContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
}));

type Props = Pick<DialogProps, 'open' | 'onClose'> & {
  confirmDelete: () => void;
};

export default function DeleteMemberDialog({
  onClose,
  open,
  confirmDelete,
}: Props) {
  const classes = useStyles();

  return (
    <Dialog open={open} onClose={onClose} PaperComponent={DialogPaper}>
      <div className={classes.cardContainer}>
        <Typography className={classes.title} gutterBottom>
          Delete Member
        </Typography>
        <Typography variant="body2" className={classes.subtext} gutterBottom>
          Permanently delete member? This action cannot be undone.
        </Typography>
      </div>
      <div className={classes.actionContainer}>
        <Button
          className={classes.buttonContainer}
          onClick={(e) => (onClose ? onClose(e, 'backdropClick') : null)}
        >
          Cancel
        </Button>
        <Button
          color="primary"
          className={classes.buttonContainer}
          onClick={() => confirmDelete()}
        >
          Delete
        </Button>
      </div>
    </Dialog>
  );
}
